import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeCPVClass } from '../models/TypeCPVClass';
import { TypeObjCPV } from '../models/TypeObjCPV';
@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeObjCPV'
  @Input() parentForm: FormGroup;
  	@Input() cpv : TypeObjCPV;

  constructor() { }

  public ngOnInit() {
  }

  addtypeCPVClass(){
		this.cpv.objetComplementaire.push(new TypeCPVClass());
	}

  removetypeCPVClass(i){
		this.cpv.objetComplementaire.splice(i, 1);
	}






  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

